import React from 'react';

import { Link, useLocation } from "react-router-dom";
import { UserIcon } from '../../icons/UserIcon';
import { Flex } from '../../components/Flex';
import { Label, Paragraph, Title } from '../../components/Text';
import { DropdownButton } from '../../components/Button';

const UserMenu = ({ name, orgName, grant, orgAlias, canImpersonate, handleMenuClick }) => {
    const { pathname } = useLocation();

    return(
        <DropdownButton
            items={[
                {
                    key: -1,
                    title: <Flex direction="column">
                            <Label size="10px" bold>organization name</Label>
                            <Title title={orgName} max="240px">{orgName}</Title>
                            <Paragraph size="12px">&lt;{grant}&gt;</Paragraph>
                        </Flex>,
                    style: { background: "var(--sp-light-grey-blue-color)"}
                },
                canImpersonate ? { key: 3, title: <Link to={"/login?switch-org=1&from=" + encodeURIComponent(pathname)}>Switch organization</Link> } : null,
                { key: 0, title: "Change password" },
                { key: 1, title: "About" },
                { key: 2, title: <Link to='/logout'>Log out</Link> }
            ]}
            onMenuClick={({ key }) => handleMenuClick(key)}
            margin={12}
        >
            <Flex style={{ cursor: "pointer" }} gap={{ right: 8 }}>
                <UserIcon />
                <Flex direction="column" justify="center">
                    <Title color="#4C5F7D">{name}</Title>
                    <Label bold>{orgAlias}</Label>
                </Flex>
            </Flex>
        </DropdownButton>
    );
};


export { UserMenu };
